import { updates } from '@/mocks/home';

const typeConfig: Record<string, { icon: string; color: string; bg: string }> = {
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  update: { icon: 'ri-refresh-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  system: { icon: 'ri-settings-3-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              更新快讯
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              最新影视资源与平台动态实时追踪
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
              {updates.map((item, idx) => {
                const config = typeConfig[item.type] || typeConfig.new;
                return (
                  <div
                    key={item.id}
                    className={`relative pb-7 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
                  >
                    <div className={`absolute -left-[29px] md:-left-[33px] w-5 h-5 rounded-full ${config.bg} border-2 border-background-50 flex items-center justify-center`}>
                      <i className={`${config.icon} ${config.color} text-xs`}></i>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                      <span className="text-xs font-bold text-foreground-500 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                        {item.date}
                      </span>
                      <span className="text-sm text-foreground-800 font-medium leading-relaxed">
                        {item.title}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}